import { useEffect, useState } from "react";
import { Paper } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";

import { Loading } from "../../../components/common/Loading";
import {
  ContentHeaderTabs, CustomTabPanel, HeaderTab
} from "../../../components/tabs/Tabs";
import LayoutService from "../../../components/common/LayoutService";
import FormServicio from "../../../components/services/admin/FormServicio";
import FormPagina from "../../../components/services/admin/FormPagina";
import { getCurrentProfile } from "../../../actions/profile";

import { useSelector, useDispatch } from "react-redux";

const CrearServicio = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loading = useSelector(state => state.profile.loading);
  const [tabSelect, setTabSelect] = useState(0);
  const { tab } = useParams();

  useEffect(() => {
    dispatch(getCurrentProfile());
  }, []);

  useEffect(() => {
    if (tab) {
      setTabSelect(Number(tab));
    }
  }, [tab]);

  const irA = (where, state) => {
    navigate(where, state);
  }

  if (loading) {
    return <Loading />
  }

  return (
    <LayoutService>
      <Paper>
        <ContentHeaderTabs
          value={tabSelect}
          onChange={(_, newValue) => navigate("/user/servicios", { state: { tab: newValue } })}
          aria-label="tabs perfil"
        >
          <HeaderTab sx={{ width: "50%" }} label="Servicios" />
          <HeaderTab sx={{ width: "50%" }} label="Página de servicios" />
        </ContentHeaderTabs>
        <CustomTabPanel
          value={tabSelect}
          index={0}
        >
          <FormServicio
            irA={irA}
          />
        </CustomTabPanel>
        <CustomTabPanel
          value={tabSelect}
          index={1}
        >
          <FormPagina
            irA={irA}
          />
        </CustomTabPanel>
      </Paper>
    </LayoutService>
  );
}

export default CrearServicio;
